export const NOTICE_ALERT_IDS = 'NOTICE_ALERT_IDS';
